/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const HOME = 'HOME';
export const FAVPROJECTS = 'FAVPROJECTS';
export const ADDFAVPROJECTS = 'ADDFAVPROJECTS';
export const DELETEFAVPROJECTS = 'DELETEFAVPROJECTS';
export const PROJECTDETAILS = 'PROJECTDETAILS';
export const GETNOTIFICATIONS = 'GETNOTIFICATIONS';
export const UPDATENOTIFICATIONS = 'UPDATENOTIFICATIONS';
export const ADDNOTIFICATIONS = 'ADDNOTIFICATIONS';
export const UPDATEBID = 'UPDATEBID';
export const FOOTERPROJECTS = 'FOOTERPROJECTS';
export const GETBIDSTRENGTH = 'GETBIDSTRENGTH';
export const LOCALITIES = 'LOCALITIES';
export const TAGS = 'TAGS';
export const RESET = 'RESET';
export const SETOVERLAYSTATE = 'SETOVERLAYSTATE';
export const SHOWWONLOSTBID = 'SHOWWONLOSTBID';
export const SHOWAUCTIONLOST = 'SHOWAUCTIONLOST';
export const SITEDRM = 'SITEDRM';
export const SETCITY = 'SETCITY';
export const SETCOMPAREDATA = 'SETCOMPAREDATA';
export const SETPROJECTLIST = 'SETPROJECTLIST';
export const SETUNITDETAILS = 'SETUNITDETAILS';
export const ADDFAVUNITS = 'ADDFAVUNITS';
export const DELETEFAVUNITS = 'DELETEFAVUNITS';
export const GETLISTINGDATA = 'GETLISTINGDATA';
export const UPDATEPROJECT = 'UPDATEPROJECT';
export const UPDATESTATS = 'UPDATESTATS';
export const UPDATEUNITS = 'UPDATEUNITS';
export const UPDATEFAVUNITSIGNAL = 'UPDATEFAVUNITSIGNAL';
export const REMOVESOLDUNIT = 'REMOVESOLDUNIT';

export default {
  HOME,
  FAVPROJECTS,
  ADDFAVPROJECTS,
  DELETEFAVPROJECTS,
  PROJECTDETAILS,
  GETNOTIFICATIONS,
  ADDNOTIFICATIONS,
  UPDATENOTIFICATIONS,
  UPDATEBID,
  FOOTERPROJECTS,
  GETBIDSTRENGTH,
  LOCALITIES,
  TAGS,
  RESET,
  SETOVERLAYSTATE,
  SHOWWONLOSTBID,
  SHOWAUCTIONLOST,
  SITEDRM,
  SETCITY,
  SETCOMPAREDATA,
  SETPROJECTLIST,
  SETUNITDETAILS,
  ADDFAVUNITS,
  DELETEFAVUNITS,
  GETLISTINGDATA,
  UPDATEPROJECT,
  UPDATESTATS,
  UPDATEUNITS,
  UPDATEFAVUNITSIGNAL,
  REMOVESOLDUNIT,
};



// WEBPACK FOOTER //
// ./src/store/modules/home/mutation-types.js